(function() {
  function loadCrossSell(cart) {
    var container = document.querySelector('#ajax-cross-sell-drawer');
    if (!container) return;

    if (!cart || !cart.items || !cart.items.length) {
      container.innerHTML = '';
      return;
    }

    var lastProductId = cart.items[cart.items.length - 1].product_id;

    fetch('/?sections=cross-sell-drawer-section&product_id=' + lastProductId)
      .then(function(res) { return res.json(); })
      .then(function(data) {
        container.innerHTML = data['cross-sell-drawer-section'] || '';

       
        container.querySelectorAll('script').forEach(function(oldScript) {
          var newScript = document.createElement('script');
          Array.from(oldScript.attributes).forEach(function(attr) {
            newScript.setAttribute(attr.name, attr.value);
          });
          newScript.textContent = oldScript.textContent;
          oldScript.parentNode.replaceChild(newScript, oldScript);
        });

       
        container.querySelectorAll('product-recommendations').forEach(function(node) {
          var clone = node.cloneNode(true);
          node.parentNode.replaceChild(clone, node);
        });
      })
      .catch(console.error);
  }

  $(document.body).on('afterCartLoad.ajaxCart', function(evt, cart) {
    loadCrossSell(cart);
  });
})();